import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemSolution } from './components/ProblemSolution';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { ForWho } from './components/ForWho';
import { ChooseRoute } from './components/ChooseRoute';
import { EbookIndex } from './components/EbookIndex';
import { ContentPreview } from './components/ContentPreview';
import { Testimonials } from './components/Testimonials';
import { PriceOffer } from './components/PriceOffer';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-white font-sans text-slate-900 selection:bg-emerald-100 selection:text-emerald-900" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <ProblemSolution data-id="element-3" />
      <WhatIsIncluded data-id="element-4" />
      <ForWho data-id="element-5" />
      <ChooseRoute data-id="element-6" />
      <EbookIndex data-id="element-7" />
      <ContentPreview data-id="element-8" />
      <Testimonials data-id="element-9" />
      <PriceOffer data-id="element-10" />
      <FAQ data-id="element-11" />
      <Guarantee data-id="element-12" />
      <Footer data-id="element-13" />
    </main>;
}